var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProvider = function SvgProvider(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__a",
    cx: 50,
    cy: 50,
    r: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#4A657B",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.262 42.674H25.738C11.714 42.674.304 54.084.304 68.107V77.4c0 1.105.895 2 2 2h59.393c1.105 0 2-.895 2-2v-9.293c0-14.024-11.41-25.433-25.435-25.433zm5.565 17.733c1.527 0 2.769 1.243 2.769 2.769s-1.242 2.769-2.769 2.769c-1.526 0-2.769-1.243-2.769-2.769s1.242-2.769 2.77-2.769zM59.697 75.4H4.303v-7.293c0-8.913 5.47-16.571 13.23-19.798v7.959h-1.08c-3.207 0-5.815 2.609-5.815 5.815v5.862c0 1.105.895 2 2 2 1.104 0 2-.895 2-2v-5.862c0-1 .814-1.815 1.815-1.815h6.009c1 0 1.815.814 1.815 1.815v5.862c0 1.105.895 2 2 2s2-.895 2-2v-5.862c0-3.206-2.609-5.815-5.815-5.815h-.93V47.09c1.36-.272 2.766-.417 4.205-.417h12.525c1.215 0 2.404.107 3.564.301v9.734c-2.759.855-4.768 3.431-4.768 6.467 0 3.733 3.036 6.769 6.768 6.769 3.733 0 6.77-3.037 6.77-6.769 0-3.036-2.011-5.612-4.77-6.467v-8.652c8.096 3.065 13.87 10.894 13.87 20.05V75.4zM34.542 7.135L30.542 7.135 30.542 9.612 28.066 9.612 28.066 13.612 30.542 13.612 30.542 16.089 34.542 16.089 34.542 13.612 37.018 13.612 37.018 9.612 34.542 9.612z",
    transform: "translate(18 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 36.48c9.03 0 16.377-7.346 16.377-16.377V2.4c0-1.105-.895-2-2-2H17.623c-1.105 0-2 .895-2 2v17.703c0 9.03 7.347 16.377 16.377 16.377zM19.623 4.4h24.754v13.703H19.623V4.4zm24.593 17.703C43.256 27.981 38.144 32.48 32 32.48c-6.144 0-11.257-4.5-12.216-10.377h24.432z",
    transform: "translate(18 25)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProvider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/provider.f9364b10556e56bbf7893a808c483aac.svg";